import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";

const TopNav: React.FC = () => {
  let navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [namePage, setNamePage] = useState("Dashboard");
  const menuRef = useRef<HTMLDivElement | null>(null);

  const handleLogOut = (event: React.FormEvent) => {
    event.preventDefault();

    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const path: string = window.location.pathname;
    const names = [
      {
        path: "/",
        value: "Dashboard",
      },
      { path: "/bills", value: "Gestión de Pagos" },
      { path: "/viaticos", value: "Gestión de Viáticos" },
    ];

    const name = names.find((n) => path.includes(n.path) && n.path !== "/");
    setNamePage(name ? name.value : "Dashboard");
  }, []);

  return (
    <>
      {/* Navbar */}
      <header className="flex items-center justify-between bg-white px-6 py-4 shadow relative">
        <h1 className="text-xl font-semibold text-gray-800">{namePage}</h1>
        <div className="flex items-center space-x-4 relative" ref={menuRef}>
          <span className="text-gray-600">Hola, User</span>
          <img
            src="https://i.pravatar.cc/40"
            alt="Avatar"
            className="h-10 w-10 rounded-full border cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          />

          {/* Dropdown menu */}
          {menuOpen && (
            <div className="absolute right-0 top-14 w-40 rounded-lg border bg-white shadow-lg">
              <ul className="flex flex-col text-gray-700">
                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  Profile
                </li>
                <li
                  onClick={handleLogOut}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  Log out
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default TopNav;
